export default __webpack_public_path__ + "static/media/facility_01_3.1a8ff8c5.png";